/**
 * @param {number} delay - delay duration in milliseconds. default: 0
 * @returns A promise that resolves after delay
 */
export const asyncDelay = (delay = 0) =>
  new Promise<void>(resolve => {
    setTimeout(() => resolve(), delay)
  })
